import { render, staticRenderFns } from "./SelectLocale.vue?vue&type=template&id=64414a62&scoped=true&"
import script from "./SelectLocale.vue?vue&type=script&lang=js&"
export * from "./SelectLocale.vue?vue&type=script&lang=js&"
import style0 from "./SelectLocale.vue?vue&type=style&index=0&id=64414a62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64414a62",
  null
  
)

export default component.exports